<template>
  <div class="user-select">
    <multiselect
      v-model="user"
      :options="availableUsers"
      placeholder="Select User"
      label="full_name"
      track-by="id"
      @select="addUser"
      @remove="removeUser"
    >
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
export default {
  name: 'SingleUserSelector',
  props: {
    parent: Object,
    parentPath: String,
    user_id: Number
  },
  components: {
    Multiselect
  },
  computed: {
    ...mapGetters(['availableUsers'])
  },
  data () {
    return {
      user: null
    }
  },
  created () {
    if (this.parent) {
      this.setParentUser()
    } else if (this.user) {
      this.setParentUserFromId()
    }
  },
  methods: {
    nameWithAvatar ({ full_name, avatar_url }) { // eslint-disable-line camelcase
      return `${full_name} — [${avatar_url}]` // eslint-disable-line camelcase
    },
    addUser (payload) {
      this.$emit('user-change', payload)
    },
    removeUser () {
      this.$emit('user-remove')
    },
    setParentUser () {
      if (this.parentPath === 'task' || this.parentPath === 'board') {
        this.user = this.parent.owner
      } else {
        this.user = this.parent.user
      }
    },
    setParentUserFromId () {
      var vm = this
      vm.user = this.availableUsers.find(user => user.id === vm.user_id)
    }
  },
  watch: {
    parent: function () {
      this.setParentUser()
    },
    user_id: function () {
      this.setParentUserFromId()
    }
  }

}
</script>

<style scoped>
</style>

<style>
.user-select .custom__tag{
  margin-right: 25px;
}
.user-select .dropdown-menu {
  padding: 0;
}
.user-select button.btn-secondary {
  padding: 0.375rem 0.65rem;
  border-radius: 25px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/selectors/users/SingleUserSelector.vue